import { Plugins, CameraResultType } from '@capacitor/core'

import b64toBlob from './b64toBlob'

const { Camera } = Plugins

const takePicture = async () => {
  const image = await Camera.getPhoto({
    quality: 100,
    allowEditing: false,
    resultType: CameraResultType.DataUrl,
    source: 'PHOTOS'
  })

  const { dataUrl: src } = image

  // Split the base64 string in data and contentType
  const block = src.split(';')
  // Get the content type of the image
  const contentType = block[0].split(':')[1]
  // Get the real base64 content of the file
  const b64Data = block[1].split(',')[1]

  const file = b64toBlob(b64Data, contentType)
  return { src, file }
}

export default takePicture
